// const searchObserverConfig = { attributes: false, childList: true, subtree: false };

// const callback = (mutationList, observer) => {
//   for (const mutation of mutationList) {
//     if (mutation.type === "childList") {
//       console.log("A child node has been added or removed.");
//     }
//   }
// };

// const searchObserver = new MutationObserver(callback);

// setTimeout(function() {
//   const searchNode = document.getElementById('salesfire-search');
//   console.log(searchNode);
//   searchObserver.observe(searchNode, searchObserverConfig);
// }, 2500);

/*===============================
XMAS 2025 - FINAL GOLD MASTER
===============================*/
(function() {
    const initXmas = function() {
        console.log("xmas firing...");

        const assetUrls = {
            flake: "https://cdn.shopify.com/s/files/1/0076/3461/6391/files/flake.png?v=1764934055",
            star: "https://cdn.shopify.com/s/files/1/0076/3461/6391/files/star.png?v=1764934055"
        };

        const targetBlocks = [
            // BLOCK 1: Main Slideshow
            { 
                id: 'block-slideshow_jyFk8G', 
                subSelector: '.slideshow-media', // Correct selector for overlay z-index issue
                flakeCount: 12, 
                starCount: 5,
                baseSize: 35    
            },
            // BLOCK 2: The Grid Items
            { 
                id: 'block-media_grid_mcnRmK',
                subSelector: '.banner-block-item',    
                flakeCount: 6,  
                starCount: 2,
                baseSize: 20    
            }
        ];

        targetBlocks.forEach(config => {
            const mainBlock = document.getElementById(config.id);
            
            if (mainBlock) {
                let targets;
                if (config.subSelector) {
                    targets = mainBlock.querySelectorAll(config.subSelector);
                } else {
                    targets = [mainBlock];
                }

                targets.forEach(container => {
                    // Safety cleanup
                    const existing = container.querySelectorAll('.xmas-decoration');
                    existing.forEach(el => el.remove());

                    // 1. Generate Flakes (No collision needed, overlap is okay/natural)
                    for (let i = 0; i < config.flakeCount; i++) {
                        createFlake(container, assetUrls.flake, config.baseSize);
                    }

                    // 2. Generate Stars (With position tracking)
                    // We pass an array to track where we put them
                    const starPositions = []; 
                    for (let i = 0; i < config.starCount; i++) {
                        createStar(container, assetUrls.star, config.baseSize, starPositions);
                    }
                });
            }
        });

        function createFlake(container, src, baseSize) {
            const img = document.createElement('img');
            img.src = src;
            img.classList.add('xmas-decoration', 'xmas-flake');

            const size = Math.random() * 25 + baseSize; 
            const leftPos = Math.random() * 90 + 5; 
            const duration = Math.random() * 8 + 10; 
            const delay = Math.random() * duration; 
            const rotSpeed = Math.random() * 10 + 5;
            const direction = Math.random() < 0.5 ? 'reverse' : 'normal';

            img.style.width = `${size}px`;
            img.style.height = `${size}px`; 
            img.style.left = `${leftPos}%`;
            img.style.animationDuration = `${duration}s, ${rotSpeed}s`;
            img.style.animationDelay = `-${delay}s, -${delay}s`; 
            img.style.animationDirection = `normal, ${direction}`;

            container.appendChild(img);
        }

        function createStar(container, src, baseSize, placedStars) {
            const img = document.createElement('img');
            img.src = src;
            img.classList.add('xmas-decoration', 'xmas-star');

            const size = Math.random() * 20 + baseSize; 
            
            // --- SPACING LOGIC START ---
            let topPos, leftPos;
            let validPosition = false;
            let attempts = 0;
            const minDistance = 15; // Minimum % distance between stars

            // Try up to 15 times to find a spot that isn't crowded
            while (!validPosition && attempts < 15) {
                topPos = Math.random() * 80 + 10; 
                leftPos = Math.random() * 80 + 10;
                
                validPosition = true; // Assume valid until proven otherwise

                // Check against every star we already placed in this container
                for (const pos of placedStars) {
                    // Calculate distance (Pythagoras theorem in % space)
                    const dx = topPos - pos.top;
                    const dy = leftPos - pos.left;
                    const distance = Math.sqrt(dx*dx + dy*dy);

                    if (distance < minDistance) {
                        validPosition = false; // Too close!
                        break; 
                    }
                }
                attempts++;
            }
            
            // Record this successful position
            placedStars.push({ top: topPos, left: leftPos });
            // --- SPACING LOGIC END ---

            const delay = Math.random() * 2;

            img.style.width = `${size}px`;
            img.style.height = `${size}px`;
            img.style.top = `${topPos}%`;
            img.style.left = `${leftPos}%`;
            img.style.animationDelay = `${delay}s`;

            container.appendChild(img);
        }

        console.log("xmas fired...");
    };

    if (document.readyState === "complete" || document.readyState === "interactive") {
        setTimeout(initXmas, 1);
    } else {
        document.addEventListener("DOMContentLoaded", initXmas);
    }
})();